module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'vycn2swx',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
